// extracted by mini-css-extract-plugin
export var Footer = "footer-module--Footer--3Smne";
export var FooterHeading = "footer-module--FooterHeading--1iWlE";
export var Icons = "footer-module--Icons--3Q7At";
export var Copyright = "footer-module--Copyright--2Ip1V";